export type IndicatorType = 'simple' | 'icon';
export type IndicatorStatus = 'info' | 'secondary' | 'success' | 'warning' | 'danger';
